<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\changeInfoManual-1.png" alt="" /></div>
                <div>
                    <p>① 画面の右上にあるプロフィール画像にマウスを置くと、プルダウンメニューが表示されます。「個人設定」メニューをクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\change_langguage_system_new_1.png" alt="" /></div>
                <div>
                    <p>② 画面右下の「編集」ボタンを押下します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\change_langguage_system_new_2.png" alt="" /></div>
                <div>
                    <p>③ 変更したい言語をプルダウンリストから選択します。</p>
                    <p>④ 「保存」ボタンを押し、新しい言語で更新します。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① 画面下部のメニューアイコンをクリックし、メニューバーを表示させます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\update_info_1.png" alt="" /></div>
                <div><p>② メニューバーから「個人設定」をクリックします。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\update_info_2.png" alt="" /></div>
                <div><p>③ 個人情報詳細画面の「編集」ボタンを押下します。個人情報編集画面を表示させます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\update_info_3.png" alt="" /></div>
                <div><p>④ 変更したい言語をプルダウンリストから選択します。「保存」ボタンを押し、新しい言語で更新します。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\change_langguage_system_mb_new_1.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/changeLanguageSystem_manual.vue